import { render, staticRenderFns } from "./bindWeixin.vue?vue&type=template&id=b59f5628&scoped=true&"
import script from "./bindWeixin.vue?vue&type=script&lang=js&"
export * from "./bindWeixin.vue?vue&type=script&lang=js&"
import style0 from "./bindWeixin.vue?vue&type=style&index=0&id=b59f5628&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59f5628",
  null
  
)

export default component.exports